module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fIL1r"))).then(() => parcelRequire('1iHdE'));